module.exports = __webpack_public_path__ + "1cf1e7e555a359b4e04378ba53b5ed3d.png";